import React from 'react'
import PropTypes from 'prop-types'
import { useFieldArray } from 'react-hook-form'

import AddIcon from '@mui/icons-material/Add'

import { FlexColumn, CenteredRowContainer } from '../styles/Containers'
import { SecondaryButton } from '../common/Button'
import BillLineItemForm from './BillLineItemForm'

const newLineItem = {
  type: 'CHARGE',
  description: '',
  quantity: null,
  unit: '',
  price: null,
  tax: null
}

function BillLineItems({ disabled = false, onEditLineItem = () => {} }) {
  const { fields, append, remove } = useFieldArray({ name: 'lineItems' })

  return (
    <FlexColumn gap="20px">
      <FlexColumn gap="15px">
        {fields.map((field, index) => (
          <BillLineItemForm key={field.id} id={`lineItems.${index}`} onDelete={() => remove(index)} disabled={disabled} onEdit={onEditLineItem} />
        ))}
      </FlexColumn>
      <CenteredRowContainer>
        <SecondaryButton onClick={() => append(newLineItem)} disabled={disabled}>
          <AddIcon />
          Add Line Item
        </SecondaryButton>
      </CenteredRowContainer>
    </FlexColumn>
  )
}

BillLineItems.propTypes = {
  disabled: PropTypes.bool,
  onEditLineItem: PropTypes.func
}

export default BillLineItems
